// extracted by mini-css-extract-plugin
export default {"wrap":"DownloadBar_wrap__BRVK1","btn":"DownloadBar_btn__0zCu1","icon":"DownloadBar_icon__PvXDu","text":"DownloadBar_text__M91Z6","minimalHover":"DownloadBar_minimalHover__zwYo4"};